/* eslint-disable */
import { React, Component, Fragment } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import avatar from "assets/img/faces/marc.jpg";
import Spinner from 'components/Spinner.js';
import moment from "moment";

import RoleList from "./RoleList";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);

export default function (props) {
  const classes = useStyles();
  return <UserProfile classes={classes} {...props} />
}

class UserProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newUserMode: props.user_id == null,
      showSpinner: true,
      showData: false,
      updating: false,
      user_id: props.user_id,
      fields: props.fields || [
            `username`,
            `email`,
            `last_name`,
            `other_names`,
            `type_id`,
            `password`,
            ].reduce((p,c) => {
                p[c] = props[c] || '';
                return p;
            }, {}),
      data: {},
      message: '',
    };
  }

  componentDidMount() {
    if (this.state.newUserMode)
    {
      this.setState({
        showSpinner: false,
        showData: true
      });
    }
    else
      this.refreshUser();
  }

  refreshUser = () => {
    var $this = this;
    fetch(`/api/shared/users/lookup/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ user_id: $this.state.user_id })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          var user = data.data.user;
          var fields = {};
          fields.username = user.username;
          fields.email = user.email;
          fields.last_name = user.last_name;
          fields.other_names = user.other_names;
          fields.type_id = user.type_id;

          $this.setState({
            data: user,
            fields: fields,
            showSpinner: false,
            showData: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  handleOnChange = (e) => {
    const fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    //const fieldErrors = this.validate(fields)
    this.setState({ fields, 
      //fieldErrors, formValidated: true, showError: null 
    });
  }

  handleUpdate = () => {
    const fields = this.state.fields;
    this.setState({
      updating: true,
    })
    //userId, string email, string last_name, string other_names
    var $this = this;
    fetch(`/api/shared/users/${$this.state.newUserMode ? 'new' : 'update'}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ 
        userId: $this.state.user_id, 
        username: fields.username,
        email: fields.email, 
        last_name: fields.last_name,
        other_names: fields.other_names,
        password: fields.password,
        type_id: fields.type_id == '' ? null : fields.type_id,
       })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          var user = data.data.user;
          var fields = {};
          fields.username = user.username;
          fields.email = user.email;
          fields.last_name = user.last_name;
          fields.other_names = user.other_names;
          fields.type_id = user.type_id;

          $this.setState({
            data: user,
            fields: fields,
            showSpinner: false,
            showData: true,
            updating: false,
            message: `User ${$this.state.newUserMode ? 'added' : 'updated'}.`,
            user_id: user.id,
            newUserMode: false,
          });
        }
        else {
          $this.setState({
            showSpinner: false,
            updating: false,
            message: `Error ${$this.state.newUserMode ? 'adding' : 'updating'} user. Please try again later.`
          });
          //alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false,
          updating: false,
          message: `Error ${$this.state.newUserMode ? 'adding' : 'updating'} user. Please try again later.`
        });
      });
  }

  render () 
  {
    const classes = this.props.classes;
    return (
      <div>
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        { this.state.showData ?
        <GridContainer>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>{this.state.newUserMode ? 'Add' : 'Update'} User {this.state.data.username}</h4>
                <p className={classes.cardCategoryWhite}>Complete user details</p>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Username"
                      id="username"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "username",
                        value: this.state.fields.username || '',
                        onChange: this.handleOnChange,
                        readOnly: !this.state.newUserMode,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Last Login"
                      id="last_login"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "last_login",
                        value: moment(this.state.data.last_login).format('YYYY/MM/D HH:mm:ss') || '',
                        readOnly: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Email address"
                      id="email"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "email",
                        value: this.state.fields.email || '',
                        onChange: this.handleOnChange,
                        readOnly: false,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Last Name"
                      id="last_name"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "last_name",
                        value: this.state.fields.last_name || '',
                        onChange: this.handleOnChange,
                        readOnly: false,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={8}>
                    <CustomInput
                      labelText="Other Names"
                      id="other_names"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "other_names",
                        value: this.state.fields.other_names || '',
                        onChange: this.handleOnChange,
                        readOnly: false,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Password"
                      id="password"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "password",
                        value: this.state.fields.password || '',
                        onChange: this.handleOnChange,
                        readOnly: false,
                        type: 'password',
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <TextField
                        id='type_id'
                        select
                        label='Type'
                        value= {this.state.fields.type_id || ''}
                        onChange={this.handleOnChange}
                        // error={this.state.fieldErrors[gi]}
                        name='type_id'
                    >
                        {/* {this.state.dropDownElements[gi] && this.state.dropDownElements[gi].map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                        ))} */}
                        <MenuItem key='disabled' value='0'>
                            Disabled
                        </MenuItem>
                        <MenuItem key='standard' value='1'>
                            Standard
                        </MenuItem>
                        <MenuItem key='admin' value='2'>
                            Admin
                        </MenuItem>
                    </TextField>
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                {this.state.updating ?
                <Fragment>
                  <Button color="primary" disabled>{this.state.newUserMode ? 'Add' : 'Update'} User</Button>
                  <Spinner/>
                </Fragment>
                :
                <Fragment>
                  <Button color="primary" onClick={this.handleUpdate}>{this.state.newUserMode ? 'Add' : 'Update'} User</Button>
                  <span>{this.state.message}</span>
                </Fragment>
                }
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            {/* <Card profile>
              <CardAvatar profile>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  <img src={avatar} alt="..." />
                </a>
              </CardAvatar>
              <CardBody profile>
                <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>
                <h4 className={classes.cardTitle}>Alec Thompson</h4>
                <p className={classes.description}>
                  Don{"'"}t be scared of the truth because we need to restart the
                  human foundation in truth And I love you like Kanye loves Kanye
                  I love Rick Owens’ bed design but the back is...
                </p>
                <Button color="primary" round>
                  Follow
                </Button>
              </CardBody>
            </Card> */}
          </GridItem>
        </GridContainer>
        : null }
        {this.state.user_id ?
        <RoleList user_id={this.state.user_id} />
        : null }
      </div>
    );
  }
}
